import API from './api';
import { graphConfig } from "intakeOptimization/auth/config";

export const getMicrosoftProfile = () => API.get(graphConfig.graphMeEndpoint);
